// @ts-nocheck
import { Dictionary } from "@insite/client-framework/Common/Types";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";

export type ObjectWithProperties = Dictionary<any> & {
    properties: Dictionary<string>;
};

const containsRequestQuote = (collection: ObjectWithProperties[] | undefined | null) => {
    return Boolean(collection?.some(x => getBooleanProperty(x.properties.rfq)));
};

export default containsRequestQuote;
